import * as icons from 'mdi-material-ui';
import clsx from 'clsx';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    alertIconDefault: {
        fontSize: 16,
        verticalAlign: 'baseline',
    },
    alertIconSuccess: {
        color: theme.constants.colorSuccess,
    },
    alertIconWarning: {
        color: theme.constants.colorWarning,
    },
    alertIconCritical: {
        color: theme.constants.colorCritical,
    },
}));

const UserStateIndicator = props => {
    const alertType = props.alertType;
    const classes = useStyles();

    return (
        <icons.Circle
            className={clsx({
                [classes.alertIconDefault]: true,
                [classes.alertIconSuccess]: alertType === '',
                [classes.alertIconWarning]: alertType === 'warning',
                [classes.alertIconCritical]: alertType === 'critical',
            })}
        />
    );
};

export default UserStateIndicator;
